<script>
  import { onMount } from "svelte";
  import Seats from "./lib/Seats.svelte";
  import { intervalDuration } from "./store.js";

  onMount(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const intervalParam = urlParams.get("interval");

    if (intervalParam) {
      const intervalValue = Number(intervalParam);
      if (!isNaN(intervalValue)) {
        if (intervalValue > 1000) {
          intervalDuration.set(intervalValue);
        }
      }
    }
  });

  let interval;
  const unsubscribeInterval = intervalDuration.subscribe((value) => {
    interval = value;
  });
</script>

<main>
  <h2>Sitzverteilung im Bundestag</h2>
  <p>Welche Abgeordneten repräsentieren Sie?</p>
  <Seats />
</main>
